<template>
  <section class="my-3 menu-category">
    <div
      v-bind:class="{ 'not-published': !category.is_published }"
      v-if="(category.items.length && category.is_published) || isMenuOwner"
    >
      <div
        class="m-heading"
        v-if="isMenuOwner"
      >
        <router-link
          class="d-block"
          :to="{
            name: 'menuCategoriesEdit',
            params: {
              categorySlug: category.slug,
            },
          }"
        >
          <h1
            v-bind:style="{ fontFamily: menu.user.font.family }"
            class="text-capitalize"
            :class="[ menu.user.menu_show_borders?'styled-border': '','border-style-'+ menu.user.menu_border_style,'border-position-'+ menu.user.menu_border_position]"
          >
            {{ category.name }}
            <span
              v-if="!category.is_published"
              class="text-warning font-weight-normal small ml-2"
            ><i class="fal fa-eye-slash"></i></span>
          </h1>
          <h2
            v-if="category.description"
            class="text-muted"
          >
            {{ category.description }}
          </h2>
        </router-link>
      </div>
      <div
        v-else
        class="m-heading"
      >
        <h1
          v-bind:id="category.slug"
          v-bind:style="{ fontFamily: menu.user.font.family }"
          class="text-capitalize"
          :class="[ menu.user.menu_show_borders?'styled-border': '','border-style-'+ menu.user.menu_border_style,'border-position-'+ menu.user.menu_border_position]"
        >
          {{ category.name }}
        </h1>
        <h2
          v-if="category.description"
          class="text-muted"
        >
          {{ category.description }}
        </h2>
      </div>

      <div class="m-ctg rounded">
        <draggable
          v-model="category.items"
          :disabled="!isMenuOwner"
          @update="handleItemSort"
          :delay="70"
          :delayOnTouchOnly="true"
          ghostClass="menu-item-ghost"
          chosenClass="menu-item-chosen"
        >
          <menuItem
            v-for="item in category.items"
            :menu="menu"
            :item="item"
            :category="category"
            :mockMenu="mockMenu"
            v-bind:key="'it-' + item.id"
            class="mb-4 p-lg-3 mb-lg-0 cursor-pointer d-block animate__animated animate__fadeIn m-itm d-block"
            v-bind:id="itemIdPrefix + item.slug"
            v-bind:data-slug="item.slug"
            v-bind:data-category-id="category.id"
          />
        </draggable>
      </div>

    </div>
  </section>
</template>

<script>
import menuMixin from "../../../mixins/menuMixin";
import accountingMixin from "../../../mixins/accountingMixin";
import draggable from "vuedraggable";
import menuItem from "./Item";
export default {
  mounted() {},
  data() {
    return {};
  },
  methods: {
    handleItemSort: function (evt) {
      this.setAppProcessing(true);
      let category = _.find(this.menu.categories, function (o) {
        return o.id == evt.item.dataset.categoryId;
      });
      let items = _.map(category.items, function (object) {
        return _.pick(object, ["id"]);
      });

      axios
        .post(
          "/api/" +
            this.$route.params.userSlug +
            "/menu/items/" +
            category.slug +
            "/sort-order",
          {
            items: items,
            _method: "PATCH",
          }
        )
        .then(
          (response) => {
            this.error = null;
            this.refreshMenu(this.$route.params.userSlug).then((result) => {
              this.setAppProcessing(false);

              let notification = {
                value: true,
                type: 1,
                message: "Menu Items Updated",
              };

              this.displayNotification(notification);
            });
          },
          (error) => {
            this.processing = false;
            this.error = error;
          }
        );
    },
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    mockMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    draggable,
    menuItem,
  },
  mixins: [accountingMixin, menuMixin],
};
</script>
